import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
function Stars() {
  return <div className="flex gap-0.5 mb-2" data-id="element-359">
      <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-360" />
      <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-361" />
      <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-362" />
      <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-363" />
      <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-364" />
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-[#111111] py-8 md:py-12 px-4 border-t border-gray-800" data-id="element-365">
      <div className="max-w-3xl mx-auto" data-id="element-366">
        <h2 className="text-2xl md:text-3xl font-black font-heading text-white text-center mb-6" data-id="element-367">
          💬 LO QUE DICEN QUIENES YA LO USAN
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-368">
          <div className="bg-gray-900 rounded-xl p-4 border border-gray-800 shadow-lg" data-id="element-369">
            <Stars data-id="element-370" />
            <p className="text-gray-300 italic font-body text-sm leading-snug mb-2" data-id="element-371">
              "Ya no siento que estoy improvisando todo el tiempo"
            </p>
            <p className="text-[10px] text-gray-500 font-semibold uppercase tracking-wide" data-id="element-372">
              — Marta G.
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 border border-gray-800 shadow-lg" data-id="element-373">
            <Stars data-id="element-374" />
            <p className="text-gray-300 italic font-body text-sm leading-snug mb-2" data-id="element-375">
              "Por primera vez pude hablar con mis padres sin discutir"
            </p>
            <p className="text-[10px] text-gray-500 font-semibold uppercase tracking-wide" data-id="element-376">
              — Diego L.
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 border border-gray-800 shadow-lg" data-id="element-377">
            <Stars data-id="element-378" />
            <p className="text-gray-300 italic font-body text-sm leading-snug mb-2" data-id="element-379">
              "Me ayudó a ordenar mi cabeza y mi familia"
            </p>
            <p className="text-[10px] text-gray-500 font-semibold uppercase tracking-wide" data-id="element-380">
              — Paula R.
            </p>
          </div>
        </div>

        <div className="text-center mt-6" data-id="element-381">
          <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 md:text-xl px-8 py-4 rounded-xl shadow-[0_0_20px_rgba(250,204,21,0.2)] transition-all duration-300 cursor-pointer font-heading text-[16px] font-[900]" data-id="element-382">
            👉 Empezar ahora con acceso inmediato
          </button>
        </div>
      </div>
    </section>;
}